import React from 'react'
import { Button, Dropdown, Icon, Menu } from 'antd'

interface IItem {
  title: string
  onClick: () => void
  disabled?: boolean | undefined
}

interface IActionsButton {
  className?: string
  items: IItem[]
}

const { Item } = Menu

const ActionsButton: React.FC<IActionsButton> = ({ className, items }) => {
  const menu = (
    <Menu>
      {items.map(({ title, onClick, disabled }, index) => (
        <Item onClick={onClick} key={index} disabled={disabled}>
          {title}
        </Item>
      ))}
    </Menu>
  )

  return (
    <Dropdown overlay={menu} className={className}>
      <Button className='rkm-btn-secondary'>
        <Icon type='more' />
      </Button>
    </Dropdown>
  )
}

export default ActionsButton
